import usePlaceholder from 'articleEditor/hooks/usePlaceholder';
import {
  basicBlockActions,
  getTransformBlockActions,
} from 'articleEditor/utils/actions';
import { MyCodeBlockElement } from 'lib-knowledge-document-structure/plateTypes';
import { RenderElementProps } from 'lib-knowledge-document-structure/slate/react';
import { useMemo } from 'react';

import s from '../baseBlock/block.module.scss';
import SortableBlockWrapper from '../baseBlock/sortableBlockWrapper';

type Props = RenderElementProps & {
  element: MyCodeBlockElement;
};

export default function CodeBlock({
  attributes,
  element,
  children,
}: Props): JSX.Element {
  const placeholder = usePlaceholder({
    placeholder: 'Type something...',
    element,
  });

  const blockActions = useMemo(
    () => [...basicBlockActions, ...getTransformBlockActions(element.type)],
    [element.type],
  );

  return (
    <SortableBlockWrapper
      className={s['blockCode']}
      element={element}
      blockActions={blockActions}
    >
      <pre
        {...attributes}
        className={s['blockContent']}
        data-placeholder={placeholder}
      >
        {children}
      </pre>
    </SortableBlockWrapper>
  );
}

// type BlockMenuProps = {
//   menuOpen: boolean;
// };
// const BlockMenu = ({ menuOpen }: BlockMenuProps) => (
//   <Dropdown className={s['blockMenu']} isOpen={menuOpen}>
//     <ButtonList>
//       <ButtonList.Item key="delete" icon="trash">
//         Delete
//       </ButtonList.Item>
//       <ButtonList.Item key="duplicate" icon="copy">
//         Duplicate
//       </ButtonList.Item>
//       <ButtonList.Item key="line-numbers" icon="list-ol">
//         Line Numbers
//       </ButtonList.Item>
//     </ButtonList>
//   </Dropdown>
// );
